import { competitionListTimeEnum } from "app/utils/const";
import type { EventType } from "../../../../../../types/eventType";
import AsianEventMarketPlaceholder from "../AsianEventMarketPlaceholder/AsianEventMarketPlaceholder";
import "./AsianEventMarketTotalContainer.scss";
import AsianEventMarketTotal from "./components/AsianEventMarketTotal";

type Props = {
  event: EventType;
  addBetSlip: (...args: Array<any>) => any;
  markets: Record<string, any>;
  highestNumberOfMarkets: number;
  line: string;
};

const AsianEventMarketTotalContainer = (props: Props): React.JSX.Element => {
  const { markets, addBetSlip, event, highestNumberOfMarkets, line } = props;
  let dummyOdds: any = [];

  for (let i = 0; i < highestNumberOfMarkets - markets.length; i++) {
    dummyOdds = [
      ...dummyOdds,
      <div className="asian-marketType-container__total--dummy" key={i}></div>,
    ];
  }

  return (
    <>
      <div className="asian-marketType-container__total">
        {markets &&
          markets.map((market, index) => {
            if (!market.runners) {
              return (
                <AsianEventMarketPlaceholder
                  marketId={market?.id}
                  line={line}
                />
              );
            }

            return (
              <div
                className={`asian-market-outer-container ${
                  line === competitionListTimeEnum.ALL ? "all-view" : ""
                }`}
                key={`${market.id}`}
              >
                {market.runners !== undefined && market.runners.length >= 1 && (
                  <AsianEventMarketTotal
                    market={market}
                    addBetSlip={addBetSlip}
                    event={event}
                  />
                )}
                {/* first market is shown in a line with 1X2, which has 3 runners
                so need to add a space so that subsequent markets align correctly*/}
                {index === 0 && <div className="asian-events-spacer"></div>}
              </div>
            );
          })}
        {dummyOdds}
      </div>
    </>
  );
};

export default AsianEventMarketTotalContainer;
